var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name !== 'ShpLogin' && _vm.$route.name !== 'ShpInitStyle' )?_c('shp-header-app'):_vm._e(),_vm._v(" "),_c('v-content',{staticClass:"mb-2"},[_c('router-view')],1),_vm._v(" "),(_vm.$route.name !== 'ShpLogin' && _vm.$route.name !== 'ShpInitStyle' )?_c('shp-footer-app'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d0d1aba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShpApp.vue
// module id = null
// module chunks = 